package com.trevorwiebe.timesheet.calendar.presentation.composables

import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.Button
import androidx.compose.material3.ButtonDefaults
import androidx.compose.material3.Card
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.OutlinedButton
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import androidx.compose.ui.window.Dialog
import com.trevorwiebe.timesheet.calendar.presentation.uiHelper.TimeOffRequestUi
import com.trevorwiebe.timesheet.core.domain.Util
import com.trevorwiebe.timesheet.core.presentation.common.responsiveDialogWidth
import com.trevorwiebe.timesheet.theme.successGreenText

/**
 * Admin-only dialog for reviewing a time-off request: approve, deny, or delete. Mirrors the
 * old admin panel's three actions. The currently selected state (approved/denied) is reflected
 * by emphasizing the matching button.
 */
@Composable
fun TimeOffReviewDialog(
    timeOffRequest: TimeOffRequestUi?,
    onApprove: () -> Unit,
    onDeny: () -> Unit,
    onDelete: () -> Unit,
    onDismiss: () -> Unit,
) {
    if (timeOffRequest == null) return

    val approved = timeOffRequest.request.approved

    Dialog(onDismissRequest = onDismiss) {
        Card(modifier = Modifier.responsiveDialogWidth(), shape = RoundedCornerShape(16.dp)) {
            Column(
                modifier = Modifier
                    .fillMaxWidth()
                    .padding(16.dp)
            ) {
                Text(
                    text = "Review Time Off",
                    fontSize = 20.sp,
                    fontWeight = FontWeight.SemiBold,
                )
                Spacer(modifier = Modifier.height(8.dp))
                Text(
                    text = timeOffRequest.employeeName ?: "Unknown",
                    fontSize = 16.sp,
                    fontWeight = FontWeight.Medium,
                )
                Text(
                    text = "Requested: ${Util.toFriendlyDate(timeOffRequest.request.requestOffTime)}",
                    fontSize = 14.sp,
                )
                if (approved != null) {
                    Text(
                        text = "${if (approved) "Approved" else "Denied"} on ${
                            Util.toFriendlyDate(timeOffRequest.request.reviewedDate)
                        }",
                        fontSize = 14.sp,
                        color = if (approved) successGreenText else MaterialTheme.colorScheme.error,
                    )
                }
                Spacer(modifier = Modifier.height(16.dp))

                Button(
                    onClick = onApprove,
                    modifier = Modifier.fillMaxWidth(),
                    colors = ButtonDefaults.buttonColors(
                        containerColor = successGreenText,
                        contentColor = Color.White,
                    ),
                ) {
                    Text(if (approved == true) "Approved" else "Approve")
                }
                Spacer(modifier = Modifier.height(8.dp))
                Button(
                    onClick = onDeny,
                    modifier = Modifier.fillMaxWidth(),
                    colors = ButtonDefaults.buttonColors(
                        containerColor = MaterialTheme.colorScheme.error,
                        contentColor = MaterialTheme.colorScheme.onError,
                    ),
                ) {
                    Text(if (approved == false) "Denied" else "Deny")
                }
                Spacer(modifier = Modifier.height(8.dp))
                OutlinedButton(
                    onClick = onDelete,
                    modifier = Modifier.fillMaxWidth(),
                ) {
                    Text("Delete")
                }
                Spacer(modifier = Modifier.height(8.dp))
                OutlinedButton(
                    onClick = onDismiss,
                    modifier = Modifier.fillMaxWidth(),
                ) {
                    Text("Cancel")
                }
            }
        }
    }
}
